import { format, isValid } from 'date-fns';

import { CALENDAR_DATE_FORMAT } from 'src/constants';
import { IDataState } from './types';

// Date formatting utility
export const formatDate = (dateString: string): string => {
  if (!dateString) return '';

  try {
    const parts = dateString.trim().split(' ');
    if (parts.length === 3) {
      const [day, month, year] = parts;
      const date = new Date(parseInt(year), parseInt(month) - 1, parseInt(day));

      if (!isValid(date)) {
        return dateString;
      }

      return format(date, CALENDAR_DATE_FORMAT);
    } else {
      const date = new Date(dateString);

      if (!isValid(date)) {
        return dateString;
      }

      return format(date, CALENDAR_DATE_FORMAT);
    }
  } catch (error) {
    console.warn('Error formatting date:', dateString, error);
    return dateString;
  }
};

// Helper functions for data checking
export const isDataLoaded = (
  dataKey: string,
  props: Record<string, IDataState>,
): boolean => {
  return props[dataKey].data !== null;
};

export const isFetchingOfDataNeeded = (
  dataKey: string,
  props: Record<string, IDataState>,
  isActive: boolean,
  reportPk: string,
  officeCode: string,
): boolean => {
  return (
    !!isActive &&
    !!reportPk &&
    !!officeCode &&
    !props[dataKey].isFetching &&
    props[dataKey].error === null &&
    !isDataLoaded(dataKey, props)
  );
};
